<template>
  <div class="d-flex align-center">
    <Icon :icon="paymentIcon" color="systemWalletGreen" class="mr-4" large />
    <Typography variant="subtitle-1"> Add a {{ paymentLanguage.toLowerCase() }} </Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";
export default {
  name: "RewardEmptyState",
  components: {
    Typography,
    Icon,
  },
  props: {
    paymentLanguage: {
      type: String,
      default: "Reward",
    },
    paymentIcon: {
      type: String,
      default: "mdi-gift-outline",
    },
  },
};
</script>
